import {isArray} from 'ramda-adjunct';

import {useGetCurrentUserInfoQuery} from '@dms/api/customer';
import {DmsDataGrid, usePermissions} from '@dms/shared';

import {RequiredTestIdProps} from 'shared/web';

import type {ActionCallback} from 'features/eag-grid';

import {USER_ABSENCE_OVERVIEW_GRID_CODE} from '../constants/constants';
import {useUserAbsenceActions} from '../hooks/useUserAbsenceActions';

const PREDEFINED_COLUMNS = ['user'] as const;

export function UserAbsenceOverviewGrid(props: RequiredTestIdProps) {
  const {data: currentUser} = useGetCurrentUserInfoQuery();
  const [canUpdate, canDelete] = usePermissions({
    permissionKeys: ['userAbsenceUpdate', 'userAbsenceDelete'],
    scopes: {
      userAbsenceUpdate: {
        // Overview grid spans all branches, own-absence access is checked separately below
        branchId: 'SKIP',
      },
      userAbsenceDelete: {
        // Overview grid spans all branches, own-absence access is checked separately below
        branchId: 'SKIP',
      },
    },
  });
  const handleAction = useUserAbsenceActions({'data-testid': props['data-testid']});

  const actionCallback: ActionCallback<typeof PREDEFINED_COLUMNS> = ({
    actionKey,
    rowId,
    getColumnData,
  }) => {
    const userId = getColumnData<{id: string}>('user')?.value?.id;
    const isOwnAbsence = Boolean(userId) && userId === currentUser?.id;

    handleAction({
      actionKey,
      userId,
      userAbsenceId: isArray(rowId) ? rowId[0] : rowId,
      canUpdate: isOwnAbsence || canUpdate,
      canDelete: isOwnAbsence || canDelete,
    });
  };

  return (
    <DmsDataGrid
      gridCode={USER_ABSENCE_OVERVIEW_GRID_CODE}
      predefinedColumns={PREDEFINED_COLUMNS}
      actionCallback={actionCallback}
      data-testid={props['data-testid']}
    />
  );
}
